import { Component, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IntegrationDetails } from '@pdqdev/pdq-shared/dist/entities';
import { IntegrationsMap } from '@services/integrations/integration.model';
import { IntegrationsService } from '@services/integrations/integrations.service';
import { ToastService } from '@storybook/services/toast/toast.service';
import { UserService } from '../../../services/user/user.service';

/** Set by pdq-core's direct-OAuth callback when the merchant clicks "Deny" on the vendor consent screen. */
const AUTH_DECLINED_QUERY_PARAM = 'authDeclined';
/** The OAuth callback sets exactly `authDeclined=1`; ignore any other value so a stray param can't show a misleading toast. */
const AUTH_DECLINED_ENABLED_VALUE = '1';
/** Exact copy required by the Klaviyo app review — states what happened plus the actionable next step. */
const AUTH_DECLINED_MESSAGE =
  "Authorization was declined. Please authorize access by clicking 'Allow' to enable integration.";

@Injectable()
@Component({
  selector: 'integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss'],
  standalone: false,
})
export class IntegrationsComponent implements OnInit {
  integrations: IntegrationsMap;
  integrationList: IntegrationDetails[] = [];
  comingSoonIntegrations: IntegrationDetails[] = [];
  constructor(
    private integrationService: IntegrationsService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.notifyIfAuthorizationDeclined();
    this.integrationService.integrations$.subscribe((integrations) => {
      this.integrations = integrations;
      this.integrationList = Object.values(integrations).filter(
        (integration) => this.userService.isAdmin() || integration.type.metadata?.released !== false,
      );
    });
  }

  /**
   * A direct-OAuth "Deny" bounces the merchant back here with ?authDeclined=1. Show the required message,
   * then strip the param so a page refresh doesn't re-trigger the toast.
   */
  private notifyIfAuthorizationDeclined(): void {
    if (this.route.snapshot.queryParamMap.get(AUTH_DECLINED_QUERY_PARAM) !== AUTH_DECLINED_ENABLED_VALUE) {
      return;
    }
    this.toastService.showToast({ mode: 'warning', message: AUTH_DECLINED_MESSAGE });
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { [AUTH_DECLINED_QUERY_PARAM]: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
